// Magnifier-with-$ brand mark. Colour follows currentColor (use text-* classes).
export const SearchDollarIcon = ({ className = "", ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="2.4" />
    <line x1="15.1" y1="15.1" x2="21" y2="21" stroke="currentColor" strokeWidth="2.9" strokeLinecap="round" />
    <text
      x="10"
      y="13.6"
      textAnchor="middle"
      fontSize="11.5"
      fontWeight="800"
      fill="currentColor"
      fontFamily="Arial, Helvetica, sans-serif"
    >
      $
    </text>
  </svg>
);

export default SearchDollarIcon;
